const {h, render, Component} = require('preact');
const {route} = require('preact-router')
const TransactionsSSAButton = require('../../self_service_actions/gplus/transactions/ssa_buttons')
const TransactionHeaderView = require('./header')
const TransactionView = require('./transaction')

class Transactions extends Component {
  constructor(props) {
    super(props);
    this.goToContactPage = this.goToContactPage.bind(this);
  }

  goToContactPage(transactionId) {
    let claimId = this.props.claimDetails.claimId
    route(`/customer_support/web/gplus/contact_channels?claim_id=${claimId}&transaction_id=${transactionId}`);
  }

  getCashbackTotal() {
    let transactions = this.props.claimDetails.transactions
    if (transactions && transactions.length > 0) {
      return (
        <div>
          <div class="total-cashback">
            {I18n.translate("js.modules.web_2018.total_cash_back")}: <span>{this.props.claimDetails.totalCashback}</span>
          </div>
          <div>{I18n.translate("js.modules.web_2018.choose_a_transaction")}</div>
        </div>
      )
    }
  }

  getTransactionsSSAButton() {
    return (
      <div class="row transaction">
        <div class="six columns first-section">
          {this.getCashbackTotal()}
        </div>
        <div className="three columns">
          <TransactionsSSAButton claimDetails={this.props.claimDetails}/>
        </div>
      </div>
    )
  }

  getTransactionsTable() {
    let transactions = this.props.claimDetails.transactions
    let transactionsView = []
    transactions.forEach(transaction => {
      if (transaction)
        transactionsView.push(
          <TransactionView
            transaction={transaction}
            goToContactPage={this.goToContactPage.bind(this)}
          />)
    });
    return transactionsView
  }

  getTransactionsView() {
    let transactions = this.props.claimDetails.transactions
    let view = <div> {this.getTransactionsSSAButton()} </div>
    if (transactions && transactions.length > 0) {
      view =
        <div>
          {this.getTransactionsSSAButton()}
          <TransactionHeaderView/>
          {this.getTransactionsTable()}
        </div>
    }
    return view
  }

  render() {
    return <div> {this.getTransactionsView()} </div>
  }
}

module.exports = Transactions

